<template>
  <div class="mobile-search">
    <div class="f--c">
      <SearchBar @search="searchHandle"></SearchBar>
      <span class="cancel-btn" @click="$router.go(-1)">{{ $t('Index.MobileSearchCenter.Cancel') }}</span>
    </div>
    <div class="search-box">
      <div class="f-b-c recent-search" v-if="recentSearches.length>0">
        <h3 style="padding-top: 0;">{{$t('inSrock.recentSearches')}}</h3>
        <!-- <span class="cancel-btn">Clear</span> -->
      </div>
      <span class="cue-word pointer ellipsis" style="display:inline-block" v-for="item in recentSearches" :key="`recent_${item}`" @click="searchHandle(item)">{{item}}</span>
      <h3 style="padding-bottom: 0.2rem;">
        <i class="iconfont icon-huo" style="color: #A6100C;"></i>
        {{$t('inSrock.hotSearches')}}
      </h3>
      <span class="cue-word pointer ellipsis" v-for="item in hotSearches" :key="`hot_${item}`" @click="searchHandle(item)">{{item}}</span>
    </div>
  </div>
</template>

<script>
import API from '@/api'
import SearchBar from '@/components/mobile/SearchBar.vue'
export default {
  components: {
    SearchBar
  },
  data() {
    return {
      recentSearches: [], // 最近搜索词列表
      hotSearches: [] // 热搜词列表
    }
  },
  created() {
    this.getSearches()
  },
  methods: {
    // 搜索
    searchHandle(searchText) {
      if (searchText === '') return
      // this.$router.push({
      //   path: '/product-list',
      //   query: {
      //     search: searchText
      //   }
      // })
      location.href = `/product-list?search=${searchText}`
    },
    getSearches() {
      API.getSearches({ userId: this.$store.state.common.userId }).then(result => {
        this.recentSearches = result.data.userHotTermsList || []
        this.hotSearches = result.data.globalHotTermsList
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.mobile-search {
  min-height: calc(100vh - 0.86rem);
  padding: 0.2rem 0.3rem;
  background: #fff;
}
.cancel-btn {
  display: inline-block;
  font-weight: 400;
  font-size: 0.28rem;
  // line-height: 0.8rem;
  margin-left: 0.04rem;
  color: #b6b6b6;
}
.search-box {
  margin-top: 0.32rem;
  .recent-search{
    padding-bottom: 0.2rem;
  }
  h3 {
    font-weight: 600;
    font-size: 0.3rem;
    line-height: 0.44rem;
    color: #10141d;

  }
}
.cue-word{
    display: inline-block;
    white-space: nowrap;
    max-width: 200px;
    padding: 5.5px 12px;
    margin: 0 10px 17px 0;
    background: #F5F7F7;
    border-radius: 100px;
    overflow: hidden;
  }
</style>
